import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { TableReactiveUrlController } from '@amlCore/tableReactive';
import { AlertPanelComponent, AlertPanelService } from '@amlCore/components';
import { ActivatedRoute, Router } from '@angular/router';
import { ResourceService, TableService, UserService, VisitedService } from '@amlCore/services';
import { RegistriesService } from '../../service';
import { FStateItem } from '../../model';
import {AccessJson, FilterParams} from '@amlCore/models';
import {Subject, Subscription} from 'rxjs';
import {RegistriesAccessEnum} from "@amlCore/enums";
import {takeUntil} from "rxjs/operators";
import {Utils} from "@amlCore/utils";

@Component({
    selector: 'app-fstate-info',
    templateUrl: './fstateInfo.component.html'
})

export class FStateInfoComponent extends TableReactiveUrlController implements OnInit, OnDestroy {
    isShowVisited = true;
    queryParamsSub:Subscription;
    fstates: FStateItem[] = [];
    @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;
    @ViewChild("alertObjToSave", {static: false}) alertObjToSave: AlertPanelComponent;
    access: AccessJson;
    $destroy = new Subject();

    constructor(
        private readonly regSrv: RegistriesService,
        private readonly userSrv: UserService,
        protected readonly activatedRoute: ActivatedRoute,
        protected readonly visitedService: VisitedService,
        protected readonly tableService: TableService,
        protected readonly router: Router,
        protected readonly alertPanelSrv: AlertPanelService
    ) {
        super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'kokcm', dir: 'ASC'});
    }

    ngOnInit(): void {
      this.access = this.userSrv.getAccess(RegistriesAccessEnum.CLS_CTFB_5016);
        this.queryParamsSub = this.activatedRoute.queryParams
            .pipe(takeUntil(this.$destroy))
            .subscribe((data: any) => {
            this._loadList(this.syncParams(data));
        });
    }

    ngOnDestroy(): void {
        this.checkScrollOptions();
        this.$destroy.next();
        this.$destroy.complete();
    }

    public onSearch() {
        const params = this.getSearchPage(this.filter);
        this.onPageChange(params);
    }
    private _loadList(params?: any): void {
        this.total = null;
        // Удаляем системные переменные
        Utils.removeKeysFromObj(params, '$refresh');
        const queryParams = this.getParams(params) as FilterParams;
        this.regSrv.getFStates(queryParams)
            .pipe(takeUntil(this.$destroy))
            .subscribe((data) => {
                this.fstates = data.content;
                this.total = data.totalElements ?? data.totalSize;
                this.scrollRun();
        });
    }

    /**
     * метод получения объекта плоского фильтра
     * @param data объект фильтра с полями
     */
    getFilterObject(data: any) {
        const filter = this.tableService.getFilterSubject(data);
        return this.getFilterPlanObject(filter);
    }

    onPageChange(params: any): void {
        const filter = this.getParams({ ...params, ...this.filter });
        this.navigate(filter);
    }

    isVisitedRow(id: string): boolean {
        return this.visitedService.getVisitedId(id);
    }

    /**
    * Метод вызываемый после импорта
    */
    importLoad(): void {
        // Подмешиваем случайную переменную для реализации обновления при импорте
        this.onPageChange({$refresh: Math.random()});

        this.alertObjToSave.open(this.alertPanelSrv.getSuccessMsg(`Перечень успешно импортирован`));
    }

}
